module.exports = __webpack_public_path__ + "static/img/four_fouth.8a181149.png";